import React from 'react';
import { ModalButton } from '../Button';
import { Modal } from './Modal';
import { MarginWrapper } from '../Styled';
import { COLORS } from '../../constants';
import { createPortal } from 'react-dom';

interface IErrorDownloadModal {
  mainColor: string;
  onCloseClick: () => void;
  onRetryClick: () => void;
}

export const ErrorDownloadModal: React.FC<IErrorDownloadModal> = (props): JSX.Element => {
  const { mainColor, onRetryClick, onCloseClick } = props;

  return createPortal(
    <Modal headerText="Oops! Error." headerColor={mainColor} onCloseClick={onCloseClick}>
      <span data-testid="error-modal-title">An error has occurred and we were unable to download the file.</span>
      <MarginWrapper margin="37px 0px 0px 0px">
        <ModalButton bGColor={mainColor} color={COLORS.white} text="Retry" onButtonClick={onRetryClick} />
      </MarginWrapper>
    </Modal>,
    document.getElementsByTagName('body')[0] as HTMLElement
  );
};
